/* ==========================================================================
   pcard-sizes — selector de tallas de la tarjeta de producto (FW26)

   Tactil: un solo gesto. Pulsar la talla la anade al carrito y abre el cajon.
   La capsula la abre el boton "+" de la tarjeta.

   Escritorio con raton (feat-20): dos gestos. La barra la abre el :hover, que
   es CSS; pulsar la talla solo la ELIGE y entra por la derecha la pastilla
   AÑADIR, que es la que anade. Mismo corte que el hover de pcard-sizes.css.

   Todo por delegacion en `document`: las tarjetas se reordenan despues de la
   carga (region-products-reorder.js) y se repintan al filtrar por AJAX, asi
   que no puede haber listeners atados a cada tarjeta.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__pcardSizesInit) return;
  window.__pcardSizesInit = true;

  var OPEN_CLASS = 'product-block--variants-open';
  /* Cuanto tiene que desplazarse la pagina para que se cierre sola. */
  var UMBRAL_SCROLL = 24;
  /* Cuanto se queda la talla en negro despues de anadirla. */
  var ACUSE_MS = 150;
  var scrollAlAbrir = 0;

  var ESCRITORIO = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
  var SIN_MOVIMIENTO = window.matchMedia('(prefers-reduced-motion: reduce)');
  /* Ancho del degradado que hay a la izquierda de la pastilla (pcard-sizes.css). */
  var DEGRADADO = 16;

  /* ── Carrito ───────────────────────────────────────────────────────────── */

  function addToCart(variantId) {
    var sectionsToUpdate = ['page-header', 'cart-drawer']
      .map(function (sel) { return document.querySelector(sel); })
      .filter(function (el) { return el; });
    var sectionIds = sectionsToUpdate
      .map(function (el) { return el.dataset.sectionId; })
      .filter(Boolean);

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    if (sectionIds.length) fd.append('sections', sectionIds.join(','));
    fd.append('sections_url', window.location.pathname);

    var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';

    return fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (res) {
        /* El 422 de add.js trae `description` ya localizada por Shopify: es el
           caso de la talla que se agota entre que se pinto la rejilla y el
           cliente la pulsa. Antes fallaba en silencio. */
        if (!res.ok) {
          return res.json().catch(function () { return {}; }).then(function (err) {
            var msg =
              (err && (err.description || err.message)) ||
              (window.theme && theme.strings && theme.strings.noStock) ||
              '';
            var handled = new Error(msg);
            handled.pcardHandled = true;
            throw handled;
          });
        }
        return res.json();
      })
      .then(function (data) {
        if (data.sections && sectionsToUpdate.length > 0) {
          sectionsToUpdate.forEach(function (el) {
            var sid = el.dataset.sectionId;
            if (sid && data.sections[sid] && typeof el.updateFromCartChange === 'function') {
              el.updateFromCartChange(data.sections[sid]);
            }
          });
        } else {
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }
        return data;
      });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.hasAttribute('open')) return;
    document.dispatchEvent(
      new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: null } })
    );
  }

  /* ── Abrir y cerrar ────────────────────────────────────────────────────── */

  function closeAll(except) {
    var open = document.querySelectorAll('.' + OPEN_CLASS);
    for (var i = 0; i < open.length; i++) {
      if (open[i] === except) continue;
      setOpen(open[i], false);
    }
  }

  function setOpen(block, open) {
    block.classList.toggle(OPEN_CLASS, open);

    /* Al abrir se guarda la posicion de la pagina: el cierre por scroll necesita
       un umbral. Al pulsar el boton el navegador lo enfoca y eso dispara por su
       cuenta un scroll de unos pocos pixeles, 35 ms despues del clic, que
       cerraba la capsula recien abierta. */
    if (open) scrollAlAbrir = window.pageYOffset || document.documentElement.scrollTop || 0;

    var btn = block.querySelector('.mobile-add-button');
    if (btn) {
      btn.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = open ? btn.dataset.labelClose : btn.dataset.labelOpen;
      if (label) btn.setAttribute('aria-label', label);

      /* En tactil el boton se oculta con display:none mientras la barra esta
         abierta. Si lo acaban de pulsar, el foco esta dentro y al ocultarlo se
         caeria al body, perdiendo el sitio: se pasa al primer chip disponible.
         preventScroll porque enfocar mueve la pagina unos pixeles, y ese scroll
         es justo lo que cierra la barra recien abierta. */
      if (open && document.activeElement === btn) {
        var primero = block.querySelector('.pcard-size:not([disabled])');
        if (primero) primero.focus({ preventScroll: true });
        else btn.blur();
      }
    }

    if (!open) hideError(block);
  }

  function showError(block, msg) {
    var box = block.querySelector('.pcard-sizes__error');
    if (!box || !msg) return;
    box.textContent = msg;
    box.hidden = false;
  }

  function hideError(block) {
    var box = block.querySelector('.pcard-sizes__error');
    if (!box) return;
    box.hidden = true;
    box.textContent = '';
  }

  /* ── Escritorio: elegir la talla y confirmar con AÑADIR ────────────────── */

  function textos() {
    return (window.theme && theme.pcardSizes) || {};
  }

  /* En escritorio la talla ya no anade: su aria-label deja de decir «Añadir la
     talla 40 a la cesta» y pasa a ser la talla, con aria-pressed. Se hace al
     entrar el raton o el foco en la tarjeta, antes de que se pueda pulsar. */
  function prepararEscritorio(barra) {
    if (barra.hasAttribute('data-pcs-desktop')) return;
    barra.setAttribute('data-pcs-desktop', '');
    var chips = barra.querySelectorAll('.pcard-size:not([disabled])');
    for (var i = 0; i < chips.length; i++) {
      chips[i].setAttribute('aria-label', chips[i].textContent.trim());
      chips[i].setAttribute('aria-pressed', 'false');
    }
  }

  function ctaDe(barra) {
    var wrap = barra.querySelector('.pcard-sizes__cta');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'pcard-sizes__cta';
      wrap.hidden = true;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pcard-sizes__cta-btn';
      btn.textContent = textos().add || 'ADD';
      wrap.appendChild(btn);
      barra.appendChild(wrap);
    }
    return wrap;
  }

  /* Tras el clic, y solo si hace falta, la fila se desliza para que la talla
     elegida quede a la izquierda del degradado. Se mide contra el borde de la
     barra y no contra la pastilla, que entra con un translateX. */
  function dejarALaVista(barra, chip, wrap) {
    var tope = barra.getBoundingClientRect().right - wrap.offsetWidth - DEGRADADO;
    var sobra = chip.getBoundingClientRect().right - tope;
    if (sobra > 0) {
      chip.parentElement.scrollBy({ left: sobra, behavior: SIN_MOVIMIENTO.matches ? 'auto' : 'smooth' });
    }
  }

  /* Al elegir, el track gana padding al final para que las tallas tapadas se
     alcancen con scroll. Pero el hueco entre tallas es dinamico —un % del ancho
     del track— y la fila va centrada: en una barra donde las tallas CABEN, ese
     padding encoge el hueco y recoloca la fila, y las tallas se juntan bajo el
     cursor (pasaba en las tarjetas de 412 de la home). Por eso antes se congela
     la geometria que hay en pantalla: hueco e inicio en px medidos.
     getComputedStyle no sirve: devuelve la expresion clamp() sin resolver. */
  function congelarFila(barra, track) {
    var chips = track.querySelectorAll('.pcard-size');
    if (!chips.length) return;
    var hueco = chips.length > 1
      ? chips[1].getBoundingClientRect().left - chips[0].getBoundingClientRect().right
      : 8;
    var inicio = chips[0].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    barra.style.setProperty('--pcs-gap', hueco + 'px');
    barra.style.setProperty('--pcs-start', inicio + 'px');
  }

  /* La talla elegida se conserva al sacar el raton de la tarjeta: al volver
     sigue en negro con la pastilla. Se limpia al anadir. */
  function elegir(barra, chip) {
    var wrap = ctaDe(barra);
    var btn = wrap.firstChild;
    if (btn.classList.contains('is-loading')) return;

    prepararEscritorio(barra);
    var previa = barra.querySelector('.pcard-size.is-chosen');
    if (previa && previa !== chip) {
      previa.classList.remove('is-chosen');
      previa.setAttribute('aria-pressed', 'false');
    }
    chip.classList.add('is-chosen');
    chip.setAttribute('aria-pressed', 'true');

    var addSize = textos().addSize;
    btn.setAttribute('aria-label', addSize ? addSize.replace('__SIZE__', chip.textContent.trim()) : btn.textContent);
    /* Solo en la primera eleccion: al cambiar de talla la fila ya esta congelada. */
    if (!barra.classList.contains('pcard-sizes--has-choice')) congelarFila(barra, chip.parentElement);
    wrap.hidden = false;
    /* Las tallas tapadas por la pastilla se alcanzan con scroll: el track gana
       al final su ancho (pcard-sizes.css). */
    barra.style.setProperty('--pcs-cta-w', wrap.offsetWidth + 'px');
    barra.classList.add('pcard-sizes--has-choice');
    dejarALaVista(barra, chip, wrap);
  }

  function limpiarEleccion(barra, chip, btn) {
    var teniaFoco = document.activeElement === btn;
    chip.classList.remove('is-chosen');
    chip.setAttribute('aria-pressed', 'false');
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
    btn.parentElement.hidden = true;
    barra.classList.remove('pcard-sizes--has-choice');
    if (teniaFoco) chip.focus({ preventScroll: true });
  }

  function confirmar(btn) {
    var barra = btn.closest('.pcard-sizes');
    var chip = barra && barra.querySelector('.pcard-size.is-chosen');
    if (!chip || !chip.dataset.variantId || btn.classList.contains('is-loading')) return;

    var block = barra.closest('.product-block');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    if (block) hideError(block);

    addToCart(chip.dataset.variantId)
      .then(function () {
        /* Mismo acuse en negro que el gesto tactil. */
        chip.classList.add('is-selected');
        setTimeout(function () { chip.classList.remove('is-selected'); }, ACUSE_MS);
        limpiarEleccion(barra, chip, btn);
        openCartDrawer();
      })
      .catch(function (err) {
        limpiarEleccion(barra, chip, btn);
        chip.classList.add('is-error');
        if (block) showError(block, err && err.message);
        setTimeout(function () { chip.classList.remove('is-error'); }, 1400);
        setTimeout(function () { if (block) hideError(block); }, 4000);
      });
  }

  function alEntrar(e) {
    if (!ESCRITORIO.matches || !e.target.closest) return;
    var block = e.target.closest('.product-block');
    var barra = block && block.querySelector('.pcard-sizes');
    if (barra) prepararEscritorio(barra);
  }

  document.addEventListener('mouseover', alEntrar, { passive: true });
  document.addEventListener('focusin', alEntrar);

  /* ── Eventos ───────────────────────────────────────────────────────────── */

  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('.pcard-sizes__cta-btn');
    if (cta) {
      e.preventDefault();
      e.stopPropagation();
      confirmar(cta);
      return;
    }

    var btn = e.target.closest && e.target.closest('.product-block .mobile-add-button');
    if (btn) {
      var block = btn.closest('.product-block');
      if (!block || block.classList.contains('product-block--comingsoon')) return;
      e.preventDefault();
      e.stopPropagation();
      var willOpen = !block.classList.contains(OPEN_CLASS);
      /* Una sola tarjeta abierta a la vez: media rejilla desplegada no se lee. */
      closeAll(block);
      setOpen(block, willOpen);
      return;
    }

    var chip = e.target.closest && e.target.closest('.pcard-size');
    if (chip) {
      if (chip.disabled) return;
      e.preventDefault();
      e.stopPropagation();

      var barra = chip.closest('.pcard-sizes');
      if (ESCRITORIO.matches && barra) {
        elegir(barra, chip);
        return;
      }

      var chipBlock = chip.closest('.product-block');
      var variantId = chip.dataset.variantId;
      if (!variantId || chip.dataset.busy === '1') return;

      chip.dataset.busy = '1';
      chip.classList.add('is-selected');
      if (chipBlock) hideError(chipBlock);

      addToCart(variantId)
        .then(function () {
          /* El acuse en negro se retira solo: sin esto el chip se quedaba negro
             para siempre. */
          setTimeout(function () { chip.classList.remove('is-selected'); }, ACUSE_MS);
          if (chipBlock) setOpen(chipBlock, false);
          openCartDrawer();
        })
        .catch(function (err) {
          chip.classList.remove('is-selected');
          chip.classList.add('is-error');
          if (chipBlock) showError(chipBlock, err && err.message);
          setTimeout(function () { chip.classList.remove('is-error'); }, 1400);
          /* El aviso se retira solo: en escritorio ningun cierre llama a hideError. */
          setTimeout(function () { if (chipBlock) hideError(chipBlock); }, 4000);
        })
        .finally(function () {
          delete chip.dataset.busy;
        });
      return;
    }

    if (!e.target.closest) return;

    /* Tocar fuera de una tarjeta abierta la cierra. */
    var abierta = e.target.closest('.' + OPEN_CLASS);
    if (!abierta) {
      closeAll(null);
      return;
    }

    /* Y tocar la propia tarjeta abierta tambien la cierra, en vez de irse a la
       ficha de producto: con la barra desplegada, el primer toque sobre la foto
       es "quitame esto de encima". El enlace sigue funcionando con la barra
       cerrada, que es el estado normal de la tarjeta.
       Se excluyen los controles que viven dentro de la foto —flechas del
       carrusel y muestras de color—, que tienen que seguir haciendo lo suyo. */
    if (e.target.closest('.image-page-button, .product-block-options__item')) return;

    /* Y tampoco cierra el toque sobre la propia barra de tallas fuera de un
       numero: la barra ES el selector, y solo cierra lo que esta fuera de el
       (decision de Hugo, 2026-08-31). Antes un dedo que fallaba el chip por
       poco perdia el selector. El chip acertado ya se ha resuelto mas arriba. */
    if (e.target.closest('.pcard-sizes')) return;
    e.preventDefault();
    closeAll(null);
  });

  document.addEventListener(
    'scroll',
    function () {
      if (!document.querySelector('.' + OPEN_CLASS)) return;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (Math.abs(y - scrollAlAbrir) > UMBRAL_SCROLL) closeAll(null);
    },
    { passive: true }
  );

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.' + OPEN_CLASS);
    if (!open) return;
    var btn = open.querySelector('.mobile-add-button');
    closeAll(null);
    if (btn) btn.focus();
  });
})();
